const primaryFontFamily = 'Roboto';
const primaryColor = 'rgba(215, 176, 48, 1)'; // Rich Gold
const secondaryColor = 'rgba(239, 212, 102, 1)'; // Amber
const backgroundColor = 'rgb(9, 9, 9)'; // Deep Black
const borderColor = 'rgba(184, 134, 11, 1)'; // Dark Goldenrod
const buttonBackgroundColor = 'rgb(255, 223, 0)'; // Golden Yellow
const buttonTextColor = 'rgb(9, 9, 9)'; // Dep Black


// Define the main colors
export const mainColors = {
  primaryColor,
  secondaryColor,
  backgroundColor,
  borderColor,
};

// Define the theme
const theme = {
  headline: {
    fontFamily: primaryFontFamily,
    color: primaryColor, // Gold for headlines
  },
  text: {
    fontFamily: primaryFontFamily,
    color: secondaryColor, // Silver for general text
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)', // Transparent
  },
  button: {
    fontFamily: primaryFontFamily,
    color: buttonTextColor, // White text for buttons
    borderColor: primaryColor, // Gold border for buttons
    backgroundColor: buttonBackgroundColor, // Bright red-orange background
  },
  rank: {
    fontFamily: primaryFontFamily,
    baseColor: primaryColor, // Gold for rankings
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)', // Transparent
  },
  field: {
    fontFamily: primaryFontFamily,
    color: secondaryColor, // Silver for text
    borderColor: borderColor, // Subtle gray borders
    backgroundColor: backgroundColor, // Black background
  },
  social: {
    color: secondaryColor, // Silver for social icons
  },
  survey: {
    fontFamily: primaryFontFamily,
    color: secondaryColor, // Silver text
    borderColor: borderColor, // Subtle gray borders
    backgroundColor: primaryColor, // Black background
  },
  wheel: {
    fontFamily: primaryFontFamily,
    color: primaryColor, // Gold text
    borderColor: secondaryColor, // Silver border
    backgroundColor: backgroundColor, // Black background
    secondaryBackgroundColor: 'rgb(128, 128, 128)', // Dark gray for subtle contrast
  },
  voucher: {
    fontFamily: primaryFontFamily,
    color: primaryColor, // Gold text for vouchers
    borderColor: secondaryColor, // Silver border
  },
  checkbox: {
    color: primaryColor, // Gold for checkbox tick
    borderColor: borderColor, // Subtle gray for border
    checkboxColor: buttonBackgroundColor, // Bright red-orange for checkbox background
    backgroundColor: backgroundColor, // Black background
  },
};

// Export both theme and mainColors
export default {
  theme,
  mainColors,
};
